<template>
	<div>
		<div class="alamat-box d-flex-between-center w-100 h-100"
		     v-for="(a, i) in alamat"
		     style="position:relative;"
		     :class="{'alamat-box-first' : i === 0}"
		>
			<!-- dropdown trigger -->
			<div class="clik"
			     :id="'dropdownMenuLink'+i"
			     data-toggle="dropdown"
			     aria-haspopup="true"
			     aria-expanded="false">
			</div>

			<!-- content -->
			<div class="d-block w-75">
				<div class="d-flex w-100">
					<div class="f-semi f-16 f-c-black m-d-2 m-r-4 nomore" v-if="a.judul !== ''">{{ a.judul }}</div>
					<span class="f-regular f-12 f-c-midgrey alamat-box-label d-flex align-items-center" v-if="a.alamat_utama === '1'">
						Alamat Utama
					</span>
				</div>
				<div class="f-regular f-14 f-c-black nomore m-d-2">
					{{ a.alamat }}
				</div>
				<div class="f-regular f-12 f-c-midgrey" v-if="a.latitude !== 0 && a.longitude !== 0">
					<i class="fas fa-map-marker f-c-midgrey f-12 m-r-4"></i>Titik lokasi terpasang
				</div>
				<div class="f-regular f-12 f-c-midgrey" v-else>
					Titik lokasi belum terpasang
				</div>
			</div>
			<div>
				<img src="../../../../public/assets/img/icons/dots-horizontal-grey.svg" alt="">
			</div>

			<!-- Dropdown -->
			<div class="dropdown-menu garis-listkomisi">
				<div class="dropdown-item icon-2" @click="setPrimary(a)">
					<span class="mar-right-10">
						<img src="../../../assets/icons/loader-primary.svg">
					</span>
					Jadikan Utama
				</div>
				<div class="dropdown-item icon-2" @click="editItem(a)">
					<span class="mar-right-10">
						<img src="../../../assets/icons/edit-20.svg">
					</span>
					Ubah
				</div>
				<div class="dropdown-item icon-2" @click="deleteItem(a)">
					<span class="mar-right-10">
						<img src="../../../assets/icons/trash-red.svg">
					</span>
					Hapus
				</div>
			</div>
		</div>
		<div class="alamat-box alamat-box-last"
		     :class="{'alamat-box-first' : alamat.length === 0}"
		     @click="addAlamat"
		>
			<div class="f-semi f-16 f-c-blue">+ Tambah alamat...</div>
		</div>
	</div>
</template>

<script>
import {mapGetters} from "vuex"

export default {
	name: "SOCardCustomerListAlamatAdd",
	props: [
		"alamat"
	],
	computed: {
		...mapGetters("customerModule", {
			customer: "getDataCreateCustomer",
		})
	},
	methods: {
		async addAlamat(payload) {
			await this.$store.commit("customerModule/resetAlamatTemp")
			this.$emit("add", payload)
		},
		setPrimary(alamat) {
			let dataCustomer = this.customer
			let alamatCustomer = this.customer.alamat_customer;
			let oldPrimaryIndex = alamatCustomer.findIndex((a) => a.alamat_utama === '1');
			let newPrimaryIndex = alamatCustomer.findIndex((a) => a === alamat);

			(oldPrimaryIndex !== -1) ? alamatCustomer[oldPrimaryIndex].alamat_utama = '0' : "";
			alamatCustomer[newPrimaryIndex].alamat_utama = '1';

			dataCustomer.alamat_customer = alamatCustomer
			this.$store.commit("customerModule/setDataCreateCustomer", dataCustomer)
		},
		editItem(alamat) {
			let temp = JSON.parse(JSON.stringify(alamat))
			console.log(temp)
			temp.alamat_utama = (temp.alamat_utama !== "0") ? [temp.alamat_utama] : []
			this.$store.commit("customerModule/setAlamatTemp", temp)
			this.$router.push("/konsumen/create/alamat")
		},
		deleteItem(alamat) {
			let dataCustomer = this.customer
			let listAlamat = this.customer.alamat_customer
			listAlamat = listAlamat.filter((a) => a !== alamat)
			dataCustomer.alamat_customer = listAlamat
			this.$store.commit("customerModule/setDataCreateCustomer", dataCustomer)
		}
	}
}
</script>

<style scoped>
.alamat-box {
	padding: 12px 16px;
	border: 1px solid #C8D0DD;
}

.alamat-box-first {
	border-top-left-radius: 4px;
	border-top-right-radius: 4px;
}

.alamat-box-last {
	border-bottom-left-radius: 4px;
	border-bottom-right-radius: 4px;
}

.alamat-box-label {
	padding: 0 4px;
	background: #EDEDED;
	border-radius: 4px;
}
</style>